
import empty from '@/views/default/empty'
export default [
  {
    path: '/pcneol',
    name: 'PCNEOL',
    component: empty,
    children: [
      {
        path: "apply",
        name: "PCNEOL_NRND_APPLY",
        meta: { externalUrl: "/vue3/#/pcneol/apply", tag: "toVue3" },
        component: empty,
      },
      {
        path: "approve",
        name: "PCNEOL_NRND_APPROVE",
        meta: { externalUrl: "/vue3/#/pcneol/approve", tag: "toVue3" },
        component: empty,
      },
      {
        path: "query",
        name: "PCNEOL_NRND_QUERY",
        meta: { externalUrl: "/vue3/#/pcneol/query", tag: "toVue3" },
        component: empty,
      }
    ]
  },
]
